import React, { useState, useEffect } from 'react';
import './Navbar.css';

interface NavbarProps {
  onPageChange: (page: 'main' | 'donate') => void;
  currentPage: 'main' | 'donate';
}

const Navbar: React.FC<NavbarProps> = ({ onPageChange, currentPage }) => {
  const [activeTab, setActiveTab] = useState('ANA SAYFA');

  // Sayfa değiştiğinde aktif tab'ı güncelle
  useEffect(() => {
    if (currentPage === 'donate') {
      setActiveTab('DONATE');
    } else if (currentPage === 'main') {
      setActiveTab('ANA SAYFA');
    }
  }, [currentPage]);

  useEffect(() => {
    const handleScroll = () => {
      if (currentPage !== 'main') return;
      
      const sections = [
        { id: 'home', name: 'ANA SAYFA' },
        { id: 'about', name: 'HAKKIMIZDA' },
        { id: 'start', name: 'NASIL BAŞLARIM' },
        { id: 'faq', name: 'FAQ' }
      ];
      
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section.id);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            if (section.name !== 'FAQ') { // FAQ section'ı için navbar'ı güncellemiyoruz
              setActiveTab(section.name);
            }
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [currentPage]);

  const scrollToSection = (sectionId: string, tabName: string) => {
    if (currentPage !== 'main') {
      onPageChange('main');
      // Ana sayfaya geçtikten sonra scroll işlemini biraz geciktir
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          setActiveTab(tabName);
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setActiveTab(tabName);
      }
    }
  };

  const handleDonateClick = () => {
    setActiveTab('DONATE');
    onPageChange('donate');
  };

  return (
    <nav className="navbar">
      <div className="pill-nav-container">
        <div className="nav-logo">
          <img src="/vise.png" alt="VISE RP" className="logo-image" />
        </div>
        
        <div className="pill-nav-center">
          <button 
            className={`pill-tab ${activeTab === 'ANA SAYFA' ? 'active' : ''}`}
            onClick={() => scrollToSection('home', 'ANA SAYFA')}
          >
            ANA SAYFA
          </button>
          <button 
            className={`pill-tab ${activeTab === 'HAKKIMIZDA' ? 'active' : ''}`}
            onClick={() => scrollToSection('about', 'HAKKIMIZDA')}
          >
            HAKKIMIZDA
          </button>
          <button 
            className={`pill-tab ${activeTab === 'NASIL BAŞLARIM' ? 'active' : ''}`}
            onClick={() => scrollToSection('start', 'NASIL BAŞLARIM')}
          >
            NASIL BAŞLARIM
          </button>
          <button 
            className={`pill-tab ${activeTab === 'DONATE' ? 'active' : ''}`}
            onClick={handleDonateClick}
          >
            DONATE
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;